import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { PROFFIT_SEARCH_PLANS } from '../../../../define/consts/proffit_search/proffit_search_service';
import { propBool, propNumber, propStr, propFunc, } from '../../../../helpers/custom-prop-types';
import HtmlLink from '../../../Ui/Common/HtmlLink';
/**
 * ヘッダーでプラン状況を表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchHeaderPlan = (props) => {
    const { canRegistrationTrial, className, isExpireApproach, isFree, isStandard, isTrial, plan, showFormModal, standardCountDown, standardTimeCountDown, trialCountDown, trialTimeCountDown, } = props;
    const planName = useMemo(() => {
        const { title } = PROFFIT_SEARCH_PLANS.find((v) => v.value === plan) || {};
        return title;
    }, [plan]);
    return (_jsx("div", Object.assign({ className: clsx('slide_search_header_plan', className, plan) }, { children: _jsxs("div", Object.assign({ className: 'plan_inner' }, { children: [isTrial && (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: 'plan_text' }, { children: `無料トライアル期間終了まであと${trialCountDown > 0
                                ? `${trialCountDown}日`
                                : `${trialTimeCountDown || 1}時間`}：` })), _jsx(HtmlLink, Object.assign({ className: 'plan_link link-text', to: '/proffit_search/account_plan' }, { children: "\u5EF6\u9577\u7533\u8ACB" }))] })), isStandard &&
                    (isExpireApproach ? (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: 'plan_text' }, { children: `${planName}終了まであと${standardCountDown > 0
                                    ? `${standardCountDown}日`
                                    : `${standardTimeCountDown || 1}時間`}：` })), _jsx(HtmlLink, Object.assign({ className: 'plan_link link-text', to: '/proffit_search/account_add' }, { children: "\u5951\u7D04\u66F4\u65B0" }))] })) : (_jsx("span", Object.assign({ className: 'plan_text' }, { children: `${planName}を利用中` })))), isFree && (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: 'plan_text' }, { children: `${planName}を利用中：` })), _jsx(HtmlLink, Object.assign({ className: 'plan_link link-text', isNoLinkComponent: canRegistrationTrial ? 'button' : undefined, onClickNoLink: showFormModal, to: '/proffit_search/account_plan' }, { children: canRegistrationTrial
                                ? 'スタンダードプランを無料体験'
                                : 'プランを変更' }))] }))] })) })));
};
SlideSearchHeaderPlan.propTypes = {
    canRegistrationTrial: propBool().isRequired,
    className: propStr(),
    isExpireApproach: propBool().isRequired,
    isFree: propBool().isRequired,
    isStandard: propBool().isRequired,
    isTrial: propBool().isRequired,
    plan: propStr().isRequired,
    showFormModal: propFunc().isRequired,
    standardCountDown: propNumber().isRequired,
    standardTimeCountDown: propNumber().isRequired,
    trialCountDown: propNumber().isRequired,
    trialTimeCountDown: propNumber().isRequired,
};
SlideSearchHeaderPlan.defaultProps = {
    className: '',
};
export default SlideSearchHeaderPlan;
